export default {"src":"https://fishbrain.com/_next/static/media/midday.131b63c9.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};